module.exports = __webpack_public_path__ + "static/media/doctorLogo.6b97c507.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/doctorLogo.png
// module id = 73
// module chunks = 1